import { render, staticRenderFns } from "./TheOrgOwnerNavbarVertical.vue?vue&type=template&id=26c9fb66&"
import script from "./TheOrgOwnerNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./TheOrgOwnerNavbarVertical.vue?vue&type=script&lang=js&"
import style0 from "./TheOrgOwnerNavbarVertical.vue?vue&type=style&index=0&id=26c9fb66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports